<div #productImageDialog class="dialog" [class.narrow]="data?.isNarrow">
  <button id="product-image-dialog-close" class="button pt-1 pr-1" [mat-dialog-close]="true">
    <mat-icon>close</mat-icon>
  </button>
  @if (!data?.isBrowser) {
    <div>
      @for (image of data?.images; track image) {
        <img [src]="getWebpImg(image?.imageUrl)" alt="product image" />
      }
    </div>
  }
  @if (data?.images.length > 0) {
    <mod-swiper
      class="bottom-swiper-nav"
      containerClass="zoom-preview-container"
      [slidesPerView]="1"
      navType="bottom"
      [initialSlide]="initialSlide"
      >
      @for (image of data?.images; track image) {
        <img
          class="swiper-slide zoom-preview-image"
          [src]="getWebpImg(image.imageUrl)"
          />
      }
    </mod-swiper>
  }
</div>
